import { createSlice } from '@reduxjs/toolkit';

const stateLoadingStart = (state, action) => {
    return { ...state, [`${action.payload.key ? `${action.payload.key}_loading`:'loading'}`]: true, [`${action.payload.key ? `${action.payload.key}_error`:'error'}`]: null };
}
const stateError = (state, action) => {
    return { ...state, [`${action.payload.key ? `${action.payload.key}_loading`:'loading'}`]: false, [`${action.payload.key ? `${action.payload.key}_error`:'error'}`]: action.payload.error };
}
const stateSuccess = (state, action, key) => {
    return { ...state, [`${action.payload.key ? `${action.payload.key}_loading`:'loading'}`]: false, [`${action.payload.key ? `${action.payload.key}_error`:'error'}`]: null, [key]: action.payload.data };
}

export const slice = createSlice({
  name: 'quiz',
  initialState: { loading: false },
  reducers: {
    
    // QUIZSET REDUCER FUNCTION

    // QUIZSET FETCH LIST
    fetchQuizQuizsetListStart: stateLoadingStart,
    fetchQuizQuizsetListSuccess: (state, action) => stateSuccess(state, action, action.payload.key ? action.payload.key : `quizset_list`),
    fetchQuizQuizsetListFailure: stateError,

    // QUIZSET FETCH ITEM
    fetchQuizQuizsetItemStart: stateLoadingStart,
    fetchQuizQuizsetItemSuccess: (state, action) => stateSuccess(state, action, action.payload.key ? action.payload.key : `quizset_item`),
    fetchQuizQuizsetItemFailure: stateError,

    // QUIZSET CREATE ITEM
    createQuizQuizsetItemStart: stateLoadingStart,
    createQuizQuizsetItemSuccess: (state, action) => stateSuccess(state, action, action.payload.key ? action.payload.key : `quizset_item`),
    createQuizQuizsetItemFailure: stateError,

    // QUIZSET UPDATE ITEM
    updateQuizQuizsetItemStart: stateLoadingStart,
    updateQuizQuizsetItemSuccess: (state, action) => stateSuccess(state, action, action.payload.key ? action.payload.key : `quizset_item`),
    updateQuizQuizsetItemFailure: stateError,

    // QUIZSET DELETE ITEM
    deleteQuizQuizsetItemStart: stateLoadingStart,
    deleteQuizQuizsetItemSuccess: (state, action) => stateSuccess(state, action, action.payload.key ? action.payload.key : `deleted_quizset`),
    deleteQuizQuizsetItemFailure: stateError,


    // QUIZITEM REDUCER FUNCTION

    // QUIZITEM FETCH LIST
    fetchQuizQuizitemListStart: stateLoadingStart,
    fetchQuizQuizitemListSuccess: (state, action) => stateSuccess(state, action, action.payload.key ? action.payload.key : `quizitem_list`),
    fetchQuizQuizitemListFailure: stateError,

    // QUIZITEM FETCH ITEM
    fetchQuizQuizitemItemStart: stateLoadingStart,
    fetchQuizQuizitemItemSuccess: (state, action) => stateSuccess(state, action, action.payload.key ? action.payload.key : `quizitem_item`),
    fetchQuizQuizitemItemFailure: stateError,

    // QUIZITEM CREATE ITEM
    createQuizQuizitemItemStart: stateLoadingStart,
    createQuizQuizitemItemSuccess: (state, action) => stateSuccess(state, action, action.payload.key ? action.payload.key : `quizitem_item`),
    createQuizQuizitemItemFailure: stateError,

    // QUIZITEM UPDATE ITEM
    updateQuizQuizitemItemStart: stateLoadingStart,
    updateQuizQuizitemItemSuccess: (state, action) => stateSuccess(state, action, action.payload.key ? action.payload.key : `quizitem_item`),
    updateQuizQuizitemItemFailure: stateError,

    // QUIZITEM DELETE ITEM
    deleteQuizQuizitemItemStart: stateLoadingStart,
    deleteQuizQuizitemItemSuccess: (state, action) => stateSuccess(state, action, action.payload.key ? action.payload.key : `deleted_quizitem`),
    deleteQuizQuizitemItemFailure: stateError,


    // QUIZRESPONSE REDUCER FUNCTION

    // QUIZRESPONSE FETCH LIST
    fetchQuizQuizresponseListStart: stateLoadingStart,
    fetchQuizQuizresponseListSuccess: (state, action) => stateSuccess(state, action, action.payload.key ? action.payload.key : `quizresponse_list`),
    fetchQuizQuizresponseListFailure: stateError,

    // QUIZRESPONSE FETCH ITEM
    fetchQuizQuizresponseItemStart: stateLoadingStart,
    fetchQuizQuizresponseItemSuccess: (state, action) => stateSuccess(state, action, action.payload.key ? action.payload.key : `quizresponse_item`),
    fetchQuizQuizresponseItemFailure: stateError,

    // QUIZRESPONSE CREATE ITEM
    createQuizQuizresponseItemStart: stateLoadingStart,
    createQuizQuizresponseItemSuccess: (state, action) => stateSuccess(state, action, action.payload.key ? action.payload.key : `quizresponse_item`),
    createQuizQuizresponseItemFailure: stateError,

    // QUIZRESPONSE UPDATE ITEM
    updateQuizQuizresponseItemStart: stateLoadingStart,
    updateQuizQuizresponseItemSuccess: (state, action) => stateSuccess(state, action, action.payload.key ? action.payload.key : `quizresponse_item`),
    updateQuizQuizresponseItemFailure: stateError,

    // QUIZRESPONSE DELETE ITEM
    deleteQuizQuizresponseItemStart: stateLoadingStart,
    deleteQuizQuizresponseItemSuccess: (state, action) => stateSuccess(state, action, action.payload.key ? action.payload.key : `deleted_quizresponse`),
    deleteQuizQuizresponseItemFailure: stateError,


    // QUIZSUBMISSION REDUCER FUNCTION

    // QUIZSUBMISSION FETCH LIST
    fetchQuizQuizsubmissionListStart: stateLoadingStart,
    fetchQuizQuizsubmissionListSuccess: (state, action) => stateSuccess(state, action, action.payload.key ? action.payload.key : `quizsubmission_list`),
    fetchQuizQuizsubmissionListFailure: stateError,

    // QUIZSUBMISSION FETCH ITEM
    fetchQuizQuizsubmissionItemStart: stateLoadingStart,
    fetchQuizQuizsubmissionItemSuccess: (state, action) => stateSuccess(state, action, action.payload.key ? action.payload.key : `quizsubmission_item`),
    fetchQuizQuizsubmissionItemFailure: stateError,

    // QUIZSUBMISSION CREATE ITEM
    createQuizQuizsubmissionItemStart: stateLoadingStart,
    createQuizQuizsubmissionItemSuccess: (state, action) => stateSuccess(state, action, action.payload.key ? action.payload.key : `quizsubmission_item`),
    createQuizQuizsubmissionItemFailure: stateError,

    // QUIZSUBMISSION UPDATE ITEM
    updateQuizQuizsubmissionItemStart: stateLoadingStart,
    updateQuizQuizsubmissionItemSuccess: (state, action) => stateSuccess(state, action, action.payload.key ? action.payload.key : `quizsubmission_item`),
    updateQuizQuizsubmissionItemFailure: stateError,

    // QUIZSUBMISSION DELETE ITEM
    deleteQuizQuizsubmissionItemStart: stateLoadingStart,
    deleteQuizQuizsubmissionItemSuccess: (state, action) => stateSuccess(state, action, action.payload.key ? action.payload.key : `deleted_quizsubmission`),
    deleteQuizQuizsubmissionItemFailure: stateError,


  },
});

export const {
  fetchQuizQuizsetListStart, fetchQuizQuizitemListStart, fetchQuizQuizresponseListStart, fetchQuizQuizsubmissionListStart,
  fetchQuizQuizsetListSuccess, fetchQuizQuizitemListSuccess, fetchQuizQuizresponseListSuccess, fetchQuizQuizsubmissionListSuccess,
  fetchQuizQuizsetListFailure, fetchQuizQuizitemListFailure, fetchQuizQuizresponseListFailure, fetchQuizQuizsubmissionListFailure,
  fetchQuizQuizsetItemStart, fetchQuizQuizitemItemStart, fetchQuizQuizresponseItemStart, fetchQuizQuizsubmissionItemStart,
  fetchQuizQuizsetItemSuccess, fetchQuizQuizitemItemSuccess, fetchQuizQuizresponseItemSuccess, fetchQuizQuizsubmissionItemSuccess,
  fetchQuizQuizsetItemFailure, fetchQuizQuizitemItemFailure, fetchQuizQuizresponseItemFailure, fetchQuizQuizsubmissionItemFailure,
  createQuizQuizsetItemStart, createQuizQuizitemItemStart, createQuizQuizresponseItemStart, createQuizQuizsubmissionItemStart,
  createQuizQuizsetItemSuccess, createQuizQuizitemItemSuccess, createQuizQuizresponseItemSuccess, createQuizQuizsubmissionItemSuccess,
  createQuizQuizsetItemFailure, createQuizQuizitemItemFailure, createQuizQuizresponseItemFailure, createQuizQuizsubmissionItemFailure,
  updateQuizQuizsetItemStart, updateQuizQuizitemItemStart, updateQuizQuizresponseItemStart, updateQuizQuizsubmissionItemStart,
  updateQuizQuizsetItemSuccess, updateQuizQuizitemItemSuccess, updateQuizQuizresponseItemSuccess, updateQuizQuizsubmissionItemSuccess,
  updateQuizQuizsetItemFailure, updateQuizQuizitemItemFailure, updateQuizQuizresponseItemFailure, updateQuizQuizsubmissionItemFailure,
  deleteQuizQuizsetItemStart, deleteQuizQuizitemItemStart, deleteQuizQuizresponseItemStart, deleteQuizQuizsubmissionItemStart,
  deleteQuizQuizsetItemSuccess, deleteQuizQuizitemItemSuccess, deleteQuizQuizresponseItemSuccess, deleteQuizQuizsubmissionItemSuccess,
  deleteQuizQuizsetItemFailure, deleteQuizQuizitemItemFailure, deleteQuizQuizresponseItemFailure, deleteQuizQuizsubmissionItemFailure
} = slice.actions;

export default slice.reducer;
